<template>
  <div class="add-bill-contact">
    <xl-dialog
      :title="
        contactInfo?.id
          ? $t('design.creditCard.createBillContact') || '新建账单联系人'
          : $t('design.creditCard.editBillContact') || '编辑账单联系人'
      "
      v-model="visible"
      width="712px"
      @close="close"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="add-contact">
        <xl-form
          ref="formRef"
          :model="contactInfo"
          :rules="rules"
          label-position="top"
          show-message
        >
          <xl-row :gutter="20">
            <xl-col :span="12">
              <xl-form-item
                prop="name"
                :label="$t('design.creditCard.contactName') || '名称'"
              >
                <xl-input
                  v-model="contactInfo.name"
                  :placeholder="
                    $t('design.creditCard.inputContactName') || '请输入名称'
                  "
                ></xl-input>
              </xl-form-item>
            </xl-col>
            <xl-col :span="12">
              <xl-form-item
                prop="title"
                :label="$t('design.creditCard.contactTitle') || '标题'"
              >
                <xl-input
                  v-model="contactInfo.title"
                  :placeholder="
                    $t('design.creditCard.inputContactTitle') || '请输入标题'
                  "
                ></xl-input>
              </xl-form-item>
            </xl-col>
            <xl-col :span="20">
              <xl-form-item
                prop="email"
                :label="$t('design.creditCard.contactEmail') || '电子邮件'"
              >
                <xl-input
                  class="email-width"
                  v-model="contactInfo.email"
                  :placeholder="
                    $t('design.creditCard.inputContactEmail') ||
                    '请输入电子邮件'
                  "
                ></xl-input>
              </xl-form-item>
            </xl-col>
            <xl-col :span="12">
              <xl-form-item
                prop="phone"
                :label="$t('design.creditCard.contactPhone') || '电话'"
              >
                <xl-area-code
                  v-model:selectValue="contactInfo.phoneArea"
                  v-model:inputValue="contactInfo.phone"
                  v-model:acturalSelect="contactInfo.codeActuralSelect"
                  :placeholder="
                    $t('design.creditCard.inputContactPhone') ||
                    '请输入电话号码'
                  "
                ></xl-area-code>
              </xl-form-item>
            </xl-col>
            <xl-col :span="12">
              <xl-form-item
                prop="telephone"
                :label="
                  $t('design.creditCard.contactTelephone') || '公司分机号'
                "
              >
                <xl-input
                  v-model="contactInfo.telephone"
                  :placeholder="
                    $t('design.creditCard.inputContactTelephone') ||
                    '请输入分机号'
                  "
                ></xl-input>
              </xl-form-item>
            </xl-col>
          </xl-row>
        </xl-form>
      </div>
      <template #footer>
        <div class="footer-button">
          <xl-button @click="close">{{
            $t("design.cancel") || "取消"
          }}</xl-button>
          <xl-button type="primary" @click="handleSubmit">{{
            $t("design.confirm") || "确定"
          }}</xl-button>
        </div>
      </template>
    </xl-dialog>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import {
  XlDialog,
  XlButton,
  XlForm,
  XlFormItem,
  XlRow,
  XlCol,
  XlInput,
  XlAreaCode,
  XlMessage,
} from "@shining3d/ui-components";
import { cloneDeep } from "lodash";
import creditCardApi from "../../api/creditCard";
import { useStore } from "vuex";
import { useLang } from "@shining3d/common-module/utils/lang.js";
import _get from 'lodash/get';

const { $t } = useLang("@shining3d/xl-design-order");
const $store = useStore();

const visible = ref(false);
const close = () => {
  visible.value = false;
};
//
const initInfo = {
  name: "",
  title: "",
  email: "",
  phone: "",
  phoneArea: "",
  codeActuralSelect: "",
  telephone: "",
  id: "",
};
const contactInfo = ref(cloneDeep(initInfo));
const formRef = ref();
const rules = {
  name: [
    {
      required: true,
      message: $t("design.creditCard.nameRequire") || "姓名不能为空",
      trigger: "blur",
    },
  ],
  email: [
		{ pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: $t('design.creditCard.emailError') || '邮箱格式不正确', trigger: 'blur' },
  ],
};
const emit = defineEmits(["getBillContact", 'getShowContact']);
const show = (row) => {
  if (row?.id) {
    contactInfo.value = row;
  } else {
    contactInfo.value = cloneDeep(initInfo);
  }
  visible.value = true;
};
// 机构id
const institutionId = _get( $store, 'state.factorySelect.id', '' );
// 提交账单联系人
const handleSubmit = () => {
  formRef.value.validate((valid) => {
    if (valid) {
      const apiFunction = contactInfo.value?.id
        ? "updateBillContact"
        : "addBillContact";
      creditCardApi[apiFunction]({
        ...contactInfo.value,
        platform: window.app?.entryName || 'dental',
        businessID: institutionId,
      }).then((res) => {
        if (res && res.status === "success") {
          XlMessage({
            type: "success",
            message: contactInfo.value?.id
              ? $t("design.creditCard.addContactSuccess") ||
                "添加账单联系人成功"
              : "编辑账单联系人成功",
          });
          visible.value = false;
          emit("getBillContact");
          emit("getShowContact");         
        }
      });
    }
  });
};
defineExpose({ show });
</script>

<style lang="scss" scoped>
.add-bill-contact {
  .add-contact {
    height: 408px;
    .email-width {
      width: 664px;
      min-width: 664px;
    }
  }
}
</style>
